exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".separator {\n  border-right: 1px solid #dfdfe0; }\n\n.icon-btn-save {\n  padding-top: 0;\n  padding-bottom: 0; }\n\n.input-group {\n  margin-bottom: 10px; }\n\n.btn-save-label {\n  position: relative;\n  left: -12px;\n  display: inline-block;\n  padding: 6px 12px;\n  background: rgba(0, 0, 0, 0.15);\n  border-radius: 3px 0 0 3px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/+login/reset/reset.component.scss
// module id = ../../../../../src/app/+login/reset/reset.component.scss
// module chunks = main